export default __webpack_public_path__ + "static/ltya-99cbe0825e0de60e64ed4c5a231c3f3d.png";